var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var resolveLanguage = dynamicRequire('resolveLanguage');
var Mssg = dynamicRequire('Mssg.jsx');
var SVGIcon = dynamicRequire('SVGIcon.jsx');

class Option extends React.Component {
    render() {
        return <div className={"lr-casefactory-choices-options-option option" + (this.isDisabled(this.props.option)?" disabled":"")}>
            <label>
                <input type="checkbox" defaultChecked={this.isChecked(this.props.option)} disabled={this.isDisabled(this.props.option)} onChange={(e) => {
                    // fix for ie
                    if(e.target.disabled){
                        return false;
                    }
                    // fix for ie
                    e.target.checked = !this.isChecked(this.props.option);

                    this.context.emitter.emit('option', this.props.option, this.isChecked(this.props.option))
                }}
                       className="lr-casefactory-choices-part-picker-part-input input"/>
                <span
                    className="lr-casefactory-choices-part-picker-part-input-label-text text-label"><Mssg __key={this.props.label} />
                </span>
                {this.hasInfo(this.props.option)?this.getInfoPopUp():""}
            </label>
        </div>
    }

    getInfoPopUp() {
        return <div className="popup-container">
            <SVGIcon identifier={"info"}/>
            <div className="tr-tooltip tr-tooltip-bottom">
                <div className="tr-tooltip-content">
                    <Mssg __key={this.getInfoText(this.props.option)}/>
                </div>
            </div>
        </div>
    }

    isChecked(option) {
        return this.props.case.options.indexOf(option) !== -1;
    };

    isDisabled(option) {
        let conflictedOption = this.props.conflicts[option];
        if(conflictedOption && this.isChecked(conflictedOption)){
            return true;
        }else{
            return false;
        }
    }
    hasInfo(option) {
        return !! this.getInfoText(option);
    }

    getInfoText(option) {
        return this.props.infos[option];
    }
}

Option.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};


module.exports = Option;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Options/Option.jsx